import Indicador from ".."
import PerfEditFields from "./components/PerfEditFields"
// import PerfGraficoPainel from "./components/PerfGraficoPainel"
// import PerfGraficoRelatorio from "./components/PerfGraficoRelatorio"
import { PerfParamFields } from "./components/PerfParamFields"
import perfReport from "./reports"
import perfReportSummary from "./reports/summary"

export default class Perf extends Indicador {
    static get fullName() {
        return "Perfilhos por Metro"
    }

    static get abbrev() {
        return "Perf"
    }

    static paramFields(tipoIndicadorField = '') {
        return <PerfParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <PerfEditFields visita={visita} TipoClass={TipoClass} />
    }

    // static getGraficoPainel(mediaAgrupadorList, fullName, nomeAgrupador, meta) {
    //     return <PerfGraficoPainel media={mediaAgrupadorList[0].media} fullName={fullName} nomeAgrupador={nomeAgrupador} />
    // }

    // static getGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro) {
    //     return PerfGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    // }

    async renderReport(visita) {
        return perfReport(this, visita)
    }

    async renderReportSummary(visita, tipoName) {
        return perfReportSummary(this, visita, tipoName)
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0
        }

        let metrosAvaliadosTotal = 0, perfilhosTotal = 0, media = 0, qtdColetas = apontamento.coletas.length

        for (const coleta of apontamento.coletas) {
            if (coleta.perfilhos) {
                perfilhosTotal += f(coleta.perfilhos)
            }
        }

        metrosAvaliadosTotal = (f(params.metrosAvaliados) * qtdColetas)

        media = (perfilhosTotal / metrosAvaliadosTotal).toFixed(2)

        apontamento.acima = f(media) > f(params.meta) ? 1 : 0
        apontamento.abaixo = f(media) < f(params.meta) ? 1 : 0

        return media
    }

    static getConformidadeStatus(conformidade, meta) {
        return ''
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = []

        for (const item of paramItems) {
            let count = 0

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.qtdGemas)) {
                    count++
                }
            }

            result.push({
                ...item,
                count: count,
            })
        }

        return result
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Faz.", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },

            { title: "Variedade", field: "insumo", width: 'auto' },

            {
                title: "Perfilhos", width: 'auto', getValue: (a) => {
                    let sum = 0
                    a.coletas.forEach(x => {
                        if (x.perfilhos) sum = sum + parseFloat(x.perfilhos).toFixed(0)
                    })
                    if (sum) return sum
                    else return '0'
                }
            },

            { title: "Resultado", field: "conformidade", width: "auto", getColor: a => IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta)) },
        ]
    }

    static getResultStr(apontamento) {
        let sumPerfilhos = 0

        apontamento.coletas?.forEach(x => {
            if (x.perfilhos)
                sumPerfilhos = sumPerfilhos + parseFloat(x.perfilhos)
        })

        return "Perfilhos: " + sumPerfilhos.toFixed(0)
    }
}
